<template>
    <div class="tw-h-screen">
        <div class="row">
            <div class="col-12 tw-text-lg tw-text-bold header-title">
                ข้อมูลร้านค้า
            </div>
            <div
                class="col-12 col-md-4 tw-mb-10 md:tw-mb-0 tw-flex tw-justify-center tw-items-center "
            >
                <div>
                    <img
                        :src="shop.shop_detail.image_url"
                        @error="imageError"
                        class="tw-max-w-full tw-height-auto"
                        alt="Shop setting"
                        v-if="shop.shop_detail.image_url"
                    />
                    <i
                        class="fa fa-image tw-text-gray-200"
                        style="font-size: 9rem"
                        v-else
                    ></i>
                </div>
            </div>

            <div class="col-12 col-md-8">
                <div class="row mb-4">
                    <div class="col-sm-6">
                        <label for="" class="shop--title">ชื่อร้านค้า</label>
                        <div class="shop--detail">
                            {{ shop.name }}
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label for="" class="shop--title">เบอร์โทรศัพท์</label>
                        <div class="shop--detail">
                            {{ shop.shop_detail.phone || "-" }}
                        </div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-sm-6">
                        <label for="" class="shop--title">Email </label>
                        <div class="shop--detail">
                            {{ shop.shop_detail.email || "-" }}
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <label for="" class="shop--title">ที่อยู่</label>
                        <div class="shop--detail">
                            {{ shop.shop_detail.address || "-" }}
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-sm-6">
                        <label for="" class="shop--title">สกุลเงิน</label>
                        <div class="shop--detail">
                            {{ shop.shop_detail.currency || "-" }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-12 tw-text-lg tw-text-bold header-title">
                แจ้งเตือนผ่านไลน์
            </div>
            <div
                class="col-12 col-md-4 tw-mb-10 md:tw-mb-0 tw-flex tw-justify-center tw-items-center "
            >
                เปิดใช้งานรับการแจ้งเตือนผ่านไลน์
            </div>
            <div
                class="col-12 col-md-4 tw-flex tw-justify-center tw-items-center"
            >
                <div
                    :class="
                        `tw-text-white tw-h-10 tw-px-4 tw-flex tw-items-cente tw-rounded ${
                            shop.line_token ? 'btn-line__active' : 'btn-line'
                        }`
                    "
                    @click="handleClickLine"
                >
                    {{ shop.line_token ? "Disconnect" : "Connect" }}
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
export default {
    props: {
        shop: {
            required: true,
            type: Object
        },
        line_redirect: {
            required: true,
            type: String
        }
    },
    data() {
        return {
            // default_img: "/images/no_pictures.png"
        };
    },
    methods: {
        imageError(event) {
            event.target.src = this.default_img;
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        async handleClickLine() {
            // console.log("test line", this.line_redirect);

            if (this.shop.line_token) {
                // revoke
                await axios
                    .post(`/backend/s/${this.shop.reference}/line-revoke`)
                    .then(res => {
                        // this.messageAlert(
                        //     "success",
                        //     "Line Disconnect",
                        //     "Disconnect success"
                        // );
                        window.location.reload();
                    })
                    .catch(err => {
                        console.log(err.response.data);
                    });
            } else {
                window.location.href = this.line_redirect;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.shop--title {
    @apply tw-mb-0 tw-text-sm tw-font-normal;
    color: var(--primary-color2);
}
.shop--detail {
    @apply tw-text-lg;
}

.btn-line {
    background: #fff;
    border-radius: 4px;
    border: 2px solid #ffe77c;
    color: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.4s ease;
    cursor: pointer;
    &:hover {
        background: #ffe77c;
        color: #000;
        font-weight: bold;
    }
    &__active {
        cursor: pointer;
        border-radius: 4px;
        border: 2px solid #ffe77c;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.4s ease;
        background: #ffe77c;
        color: #000;
        font-weight: bold;
        &:hover {
            background: #fff;
            color: #000;
            opacity: 0.8;
        }
    }
}
.card .body {
    height: 80vh !important;
}
.header-title {
    background: #ffe77c;
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    margin-bottom: 40px;
    padding-left: 20px;
    font-weight: bold;
    margin-top: 40px;
}
</style>
